import { c as _c } from "react/compiler-runtime";
import RatingsByCriteria from '@/components/modules/rating/RatingsByCriteria';
import NoRating from './NoRating';
import RatingsByType from './RatingsByType';
const RatingsDetail = t0 => {
    const $ = _c(6);
    const { byType, className } = t0;
    const isOneType = byType && byType.length === 1;
    let t1;
    if ($[0] !== byType || $[1] !== isOneType) {
        t1 = byType && byType.length > 0 ? isOneType ? <RatingsByCriteria {...byType[0].criteria}/> : <RatingsByType byType={byType}/> : <NoRating />;
        $[0] = byType;
        $[1] = isOneType;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    const content = t1;
    let t2;
    if ($[3] !== className || $[4] !== content) {
        t2 = <div className={className}>{content}</div>;
        $[3] = className;
        $[4] = content;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    return t2;
};
export default RatingsDetail;
